import { connect, Provider } from "react-redux";
import { bindActionCreators } from "redux";

export default function webConnect(...args) {
  return connect(...args);
}

export { bindActionCreators, Provider };
